import Model  from '@/util/models';

export default class dashboard extends Model { 
    backend = '/ppdb/dashboard/'; 
    
    test(){
        return this.api.get(this.backend + 'test');
    }        
    
    currentStatus(){
        return this.api.get(this.backend + 'current-status');
    } 
    
    setCetak(){
        return this.api.get(this.backend + 'set-cetak');
    }
    
    viewAdministrasi(params){
        return this.api.get(this.backend + 'view-administrasi', params).then(res=>{
          return res.status === 200 ? res.data : {};
        }); 
    }  

    settings(params={}){
        return this.api.get(this.backend + 'settings', params).then(res => {          
          return res.status == 200 ? res.data : [];
        });
    }
    
    saveAdministrasi(formdata){
        return this.api.post(this.backend + 'save-administrasi', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
    
    completeAdministrasi(formdata){
        return this.api.post(this.backend + 'complete-administrasi', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }    
    
    setavatar(formdata){
        return this.api.post(this.backend + 'setavatar', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
    
    getavatar(params){
        return this.api.get(this.backend + 'getavatar', params); 
    }        
    
    quetionnaires(params){
        return this.api.get(this.backend + 'quetionnaires', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }

    kelengkapans(){
        return this.api.get(this.backend + 'kelengkapans').then(res=>{
            return res.status === 200 ? res.data : {};
        });
    }
    
    saveAngket(body, params){
        return this.api.post(this.backend+'save-angket', body, params);
    }

    setQuranDate(body){
        return this.api.post(this.backend+'set-quran-date', body);
    }

    setVoucher(body){
        return this.api.post(this.backend+'set-voucher', body);
    }

    soalUjian(params){
        return this.api.get(this.backend + 'soal-ujian', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }

    saveUjian(body, params){
        return this.api.post(this.backend+'save-ujian', body, params);
    }
    
    provinsis(params){
        return this.api.get(this.backend + 'provinsis', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }
    
    kotas(params){
        return this.api.get(this.backend + 'kotas', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }
    
    kecamatans(params){
        return this.api.get(this.backend + 'kecamatans', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }
    
    kelurahans(params){
        return this.api.get(this.backend + 'kelurahans', params).then(res=>{
            return res.status === 200 ? res.data : [];
        });
    }
    
    tingkats(){       
        return this.api.get(this.backend + 'tingkats').then(res => {
            return res.status === 200 ? res.data : [];
        })
    } 
    
    
}

